import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgFilling = (props: ToothSvgComponentProps) => (
  <svg
    width={18 * (props.wx ?? 1)}
    height={27 * (props.hx ?? 1)}
    viewBox="0 0 18 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M9.04426 1.80476C10.377 1.80476 13.8433 -0.118494 15.8455 1.98137C17.4498 3.66421 16.8573 7.71066 15.7076 10.4346C15.2797 11.4477 15.2982 12.704 15.3838 13.8779C15.7276 18.5799 14.1937 25.8182 12.7915 25.7335C11.3537 25.6464 11.4825 17.0265 9.31196 16.2744C8.04385 15.835 7.7481 18.0952 7.46662 20.2118C7.12998 22.7439 7.32825 25.3884 6.61266 25.6597C5.77962 25.9753 4.19912 23.855 3.35943 20.0037C2.9082 17.9343 2.71372 15.5964 2.77078 13.9069C2.80787 12.8135 2.8093 11.4481 2.38136 10.4351C1.23118 7.71161 0.638731 3.66469 2.24347 1.98185C4.24572 -0.118018 7.71197 1.80523 9.04474 1.80523L9.04426 1.80476Z"
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinejoin="round"
    />
    <path
      d="M13.2353 6.14262C10.9052 3.60047 10.5239 4.94687 8.97236 4.94687C7.42085 4.94687 7.04511 3.51914 4.80682 6.14252C3.04484 8.20764 4.80682 10.9589 5.40886 12.163C5.90694 13.3891 7.59616 13.3671 9.02108 13.3671C10.2252 13.3671 12.1352 13.3896 12.6333 12.163C13.235 11.561 15.1023 8.17978 13.2353 6.14262Z"
      fill={props.findingsFill || '#FF5140'}
    />
  </svg>
);
export default SvgFilling;
